import { StyledLoadingSpinner } from './loading-spinner.styles';

export const LoadingSpinner = (props: { size?: string; color?: string, thickness?: string }) => {
    return <StyledLoadingSpinner size={ props.size } color={ props.color } thickness={ props.thickness } />;
};
